import {
  GET_ORG_CHART_REQUESTED,
} from 'consts/actionTypes';

export const getOrgchart = () => ({
  type: GET_ORG_CHART_REQUESTED,
});
